<div *ngIf="!isAuthyCallback && (!selectedPage || selectedPage==='KEYCLOAK')">
    <login></login>
</div>

<div *ngIf="isAuthyLoggedIn">
    <login></login>
</div>
